import {BILLING_CLOSE_CREDIT_FORM} from './action-types';

export interface ICloseForm {
    type: string
    data: boolean
}

export const closeCreditForm = (data: boolean): ICloseForm => ({
    type: BILLING_CLOSE_CREDIT_FORM,
    data
})
